const MyClientHelper = {
  rangeScore: ({ num, list }) => {
    if (num === 0) {
      return list[0];
    } else if (num >= 1 && num <= 20) {
      if (num >= 5 && num < 10 && list[1] < 4) {
        return list[1];
      } else if (num >= 11 && num < 15 && list[2] < 4) {
        return list[2];
      } else if (num >= 15 && num <= 20 && list[3] <= 4) {
        return list[3];
      }
      let _other_item = list.filter((e) => e > 4);
      return list[0] ? list[0] : _other_item[_other_item.length - 1];
    } else if (num >= 21 && num <= 40) {
      let _list = list.filter((e) => e >= 5 && e <= 6);

      if (num >= 31 && num <= 40 && _list[1] <= 6) {
        return _list[1];
      }
      let _other_item = list.filter((e) => e > 6);
      return _list[0] ? _list[0] : _other_item[_other_item.length - 1];
    } else if (num >= 41 && num <= 70) {
      let _list = list.filter((e) => e > 6);

      if (num >= 51 && num <= 70 && _list[1] <= 8) {
        return _list[1];
      }
      let _other_item = list.filter((e) => e <= 6);
      return _list[0] ? _list[0] : _other_item[_other_item.length - 1];
    } else if (num >= 71 && num <= 90) {
      let _list = list.filter((e) => e > 8);

      if (num >= 81 && num <= 90 && _list[1] <= 10) {
        return _list[1];
      }
      let _other_item = list.filter((e) => e <= 9);
      return _list[0] ? _list[0] : _other_item[_other_item.length - 1];
    } else if (num >= 91 && num <= 100) {
      let _list = list.filter((e) => e > 9);
      if (_list[0]) {
        return _list[0];
      } else {
        let _other_item = list.filter((e) => e <= 9);
        return _list[0] ? _list[0] : _other_item[_other_item.length - 1];
      }
    } else {
      return list[list.length - 1];
    }
  },
  getAciveId: ({ modelPortfolios, number }) => {
    if (!modelPortfolios || !number) return;
    let id;
    for (let i in modelPortfolios) {
      if (modelPortfolios[i] === number) {
        id = i;
      }
    }
    return id;
  },
  getMappedID: ({ score, modelPortfolios }) => {
    if (!score || !modelPortfolios) return;
    let list = Object.values(modelPortfolios).sort((a, b) => a - b);
    let myNum = MyClientHelper.rangeScore({ num: score, list });
    let id = MyClientHelper.getAciveId({ modelPortfolios, number: myNum });

    return id;
  },
};

export default MyClientHelper;



// WEBPACK FOOTER //
// ./src/components/pages/MyClients/myClientHelper.js